<template>
    <div class="inline-flex items-center rounded-full bg-gray-100 p-0.5 mt-2" role="group" aria-label="Langue">
        <button
            v-for="lang in langs"
            :key="lang"
            type="button"
            @click="handleSwitchLang(lang)"
            :aria-pressed="locale === lang"
            class="min-w-[2.25rem] rounded-full px-2.5 py-1 text-xs font-semibold tracking-wide transition-colors focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-1"
            :class="locale === lang
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-800'"
        >
            {{ lang.toUpperCase() }}
        </button>
    </div>
</template>

<script>
export default {
    computed: {
        locale() {
            return this.$store.state.config.locale;
        },
        langs() {
            return this.$store.state.config.langs;
        },
    },
    methods: {
        handleSwitchLang(lang) {
            if (this.locale === lang) {
                return;
            }

            this.$store.dispatch('config/setLocale', lang);
            const current = this.$route;
            const params = Object.assign({}, current.params, { locale: lang });

            if (current.name) {
                this.$router.push({ name: current.name, params, query: current.query });
            } else {
                this.$router.push({ path: `/${lang}` });
            }
        },
    },
};
</script>
